import * as fs from 'node:fs';
import { discoverGitReposUnderRoot } from '../../git/discover-repos.js';
import { forEachWithGitYield } from '../../git/git-runtime.js';
import type { IsolatedWorktreeBinding } from '../isolated-worktree-binding.js';
import { addIsolatedRepoWorktree } from './add-isolated-repo-worktree.js';
import { resolveIsolatedScopeDir } from './resolve-isolated-scope-dir.js';
import type { PrepareNewIsolatedWorktreesOptions } from './types.js';

export async function prepareNewIsolatedWorktrees(
  options: PrepareNewIsolatedWorktreesOptions,
): Promise<IsolatedWorktreeBinding | null> {
  const {
    kind,
    scopeId,
    branch,
    worktreesRootPath,
    bridgeRoot,
    layout,
    log,
    worktreeBaseBranches,
    existingBranch,
  } = options;

  const { bridgeResolved, scopeDir } = resolveIsolatedScopeDir({
    worktreesRootPath,
    bridgeRoot,
    kind,
    scopeId,
    layout,
  });

  const repos = await discoverGitReposUnderRoot(bridgeResolved);
  if (repos.length === 0) {
    log(`[worktrees] No Git repositories under bridge root; skipping ${kind} worktree creation.`);
    return null;
  }

  const worktreePaths: string[] = [];
  fs.mkdirSync(scopeDir, { recursive: true });

  await forEachWithGitYield(repos, async (repo) => {
    const worktreePath = await addIsolatedRepoWorktree({
      kind,
      bridgeResolved,
      scopeDir,
      repoAbsolutePath: repo.absolutePath,
      branch,
      existingBranch,
      worktreeBaseBranches,
      log,
    });
    if (worktreePath) worktreePaths.push(worktreePath);
  });

  if (worktreePaths.length === 0) return null;
  return {
    parentPath: scopeDir,
    repoCheckoutPaths: worktreePaths,
  };
}
